<template>
  <footer class="ibcgp-footer">
    <div class="footer-main ibcgp-footer-inner">
      <div class="container">
        <div class="row align-items-start">
          <div class="col-lg-2 col-md-4 col-6 mb-3 mb-lg-0">
            <a href="/" class="d-inline-block">
              <img
                class="ibcgp-footer-logo"
                src="../../assets/images/ibcgp/logo-branca.png"
                alt="IBCGP"
              >
            </a>
          </div>

          <div class="col-lg-3 col-md-8 col-6 mb-3 mb-lg-0">
            <h6 class="ibcgp-footer-title">Contato</h6>
            <ul class="ibcgp-footer-list">
              <li>
                <a href="tel:556730424800">+55 (67) 3042-4800</a>
              </li>
              <li>
                <a href="mailto:contato@ibcgp.org.br">contato@ibcgp.org.br</a>
              </li>
              <li class="small">
                <a
                  href="https://www.google.com/maps/place/Delta+Contabilidade+e+Assessoria/@-20.480555,-54.598586,14z/data=!4m5!3m4!1s0x0:0xa89e5bf31511351f!8m2!3d-20.4805591!4d-54.5986016?hl=pt-BR"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Rua Santana, 143 — Campo Grande/MS
                </a>
              </li>
            </ul>
          </div>

          <div class="col-lg-3 col-md-6 mb-3 mb-lg-0">
            <h6 class="ibcgp-footer-title">Soluções</h6>
            <ul class="ibcgp-footer-list">
              <li>
                <a href="/#solucoes">Visão geral</a>
              </li>
              <li>
                <a :href="links.plataformaGestao" target="_blank" rel="noopener noreferrer">Gestão Rural</a>
              </li>
              <li>
                <a :href="links.concursosPublico" target="_blank" rel="noopener noreferrer">Portal de concursos</a>
              </li>
              <li>
                <a :href="links.cursosLanding" target="_blank" rel="noopener noreferrer">Nucleo de Gestão</a>
              </li>
              <!-- <li>
                <a :href="links.cursosPlataformaLogin" target="_blank" rel="noopener noreferrer">Área do aluno</a>
              </li> -->
            </ul>
          </div>

          <div class="col-lg-4 col-md-6">
            <h6 class="ibcgp-footer-title">Institucional</h6>
            <ul class="ibcgp-footer-list ibcgp-footer-list-inline-md">
              <li><a href="/">Início</a></li>
              <li><a href="/sobre">O Instituto</a></li>
              <li><a href="/concursos">Publicações Concursos</a></li>
              <li><a href="/publicacoes">Publicações</a></li>
              <li><a href="/contato">Contato</a></li>
            </ul>
            <a
              class="ibcgp-footer-insta mt-2 d-inline-flex align-items-center"
              href="https://www.instagram.com/ibcgp/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram IBCGP"
            >
              <i class="ti-instagram"></i>
              <span class="ml-1">@ibcgp</span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-bottom-bar text-center py-2">
      <small class="mb-0 d-block ibcgp-footer-copy">
        © 2026
        <a href="/" class="ibcgp-footer-copy-link">IBCGP</a>
        — Todos os direitos reservados
      </small>
    </div>
  </footer>
</template>

<script>
import links from '../../consts/links.js'

export default {
  data () {
    return { links }
  }
}
</script>

<style scoped>
</style>
